<template>
	<div>
		<flCabecalhoForm
			:msg="_traducao('global', 'obrigatorio')"
			color="#1976D2"
			cls="print-titulo-form-40"
			:texto="cargaBagagem + ' transportada'"
		/>

		<div class="row">
			<!-- EXISTE TRANSPORTE? -->
			<div class="col-xs-12 form-group">
				<label>* Há {{cargaBagagem}} a ser transportada?</label> <br />
				<div class="btn-group print-button-group" role="group">
					<flSimNao v-model="form.carga" :disabled="solicitacao_aprovada" />
				</div>
			</div>
		</div>

		<!-- BOTÃO EXISTE CARGA? -->
		<div class="row" v-if="!solicitacao_aprovada && !flagPeso">
			<div class="col-xs-6 col-md-2 form-group" v-show="form.carga">
				<label>* {{ _traducao('global', 'quantas') }}</label> <br />
				<a
					href="#"
					class="pass-btn-mais text-center"
					@click.prevent="addCarga('+')"
				>
					<i style="margin-top: 7px" class="fa fa-plus fa-fw"></i>
				</a>
				<a
					href="#"
					class="pass-btn-menos text-center"
					@click.prevent="addCarga('-')"
				>
					<i style="margin-top: 8px" class="fa fa-minus fa-fw"></i>
				</a>
				<input
					:disabled="solicitacao_aprovada"
					type="text"
					:value="cargaArray.length"
					style="cursor: default; background: #fff"
					v-mask="'00'"
					class="form-control text-center input-sm"
				/>
			</div>
		</div>
		<!-- CARGAS -->
		<div class="row" v-if="flagPeso && form.carga">
			<div
				class="col-xs-12 col-md-3 form-group"
				:class="{'has-error': form.cargaArray[0].pesoErro != ''}"
			>
				<label>* {{ _traducao('global', 'pesoAprox') }}:</label>
				<money
					v-model="form.cargaArray[0].peso"
					step="0.1"
					placeholder="0,0"
					v-bind="_vpercem(1)"
					class="form-control input-sm"
					:disabled="solicitacao_aprovada"
				></money>
				<p class="help-block" v-if="form.cargaArray[0].pesoErro != ''">
					{{ form.cargaArray[0].pesoErro }}
				</p>
			</div>
		</div>
		<div class="row" v-if="!flagPeso">
			<div
				class="col-xs-4"
				v-for="(item, index) in form.cargaArray"
				:key="index"
			>
				<div class="trecho-borda" style="margin-bottom: 10px">
					<div class="row">
						<!-- TIPO CARGA -->
						<div
							class="col-xs-12 col-md-12 form-group"
							:class="{'has-error': item.erro_tipo_carga != ''}"
						>
							<label>* Tipo de Carga:</label>
							<div style="display: flex">
								<select
									class="form-control input-sm"
									v-model="item.tipo_carga"
									@change="alterarTipoCarga(index)"
									:disabled="solicitacao_aprovada"
								>
									<option value="">
										{{ _traducao('global', 'escolha').toUpperCase() }}
									</option>
									<option
										v-for="tipo in tipoCarga"
										:key="tipo.id + 'tipoCarga'"
										:value="tipo.id"
									>
										{{ tipo.descricao }}
									</option>
								</select>
								<button
									type="button"
									class="btn btn-sm btn-info pull-left"
									style="margin-left: 5px"
									@click="abrirCadastroTipoCarga(index)"
								>
									<i class="fa fa-plus fa-fw"></i>
									{{ _traducao('global', 'novo') }}
								</button>
							</div>
							<p class="help-block" v-if="item.erro_tipo_carga != ''">
								{{ item.erro_tipo_carga }}
							</p>
						</div>
						<!-- Descrição da Carga -->
						<div
							class="col-xs-12 col-md-12 form-group"
							:class="{'has-error': item.descricaoErro != ''}"
						>
							<label
								><span>*</span> {{ _traducao('global', 'descricao') }}:</label
							>
							<input
								type="text"
								:disabled="solicitacao_aprovada"
								v-model="item.descricao"
								@keyup="item.cargaErro = ''"
								class="form-control input-sm"
							/>
							<p class="help-block" v-show="item.descricaoErro != ''">
								{{ item.descricaoErro }}
							</p>
						</div>
					</div>
					<div class="row">
						<div class="col-xs-6 col-md-4 form-group">
							<label>{{ _traducao('global', 'cargaPerigosa') }}?</label> <br />
							<div class="btn-group print-button-group" role="group">
								<flSimNao
									:disabled="solicitacao_aprovada"
									v-model="item.carga_perigosa"
								/>
							</div>
						</div>

						<div class="col-xs-6 col-md-4 form-group">
							<label>{{ _traducao('global', 'cargaLiquida') }}</label> <br />
							<div class="btn-group print-button-group" role="group">
								<flSimNao
									:disabled="solicitacao_aprovada"
									v-model="item.carga_liquida"
								/>
							</div>
						</div>

						<!-- PESO CARGA -->
						<div
							class="col-xs-12 col-md-4 form-group"
							:class="{'has-error': item.pesoErro != ''}"
						>
							<label>* {{ _traducao('global', 'pesoAprox') }}:</label>
							<input
								type="number"
								step="0.1"
								placeholder="0,0"
								v-model="item.peso"
								class="form-control input-sm"
								:disabled="solicitacao_aprovada"
							></input>
							<p class="help-block" v-if="item.pesoErro != ''">
								{{ item.pesoErro }}
							</p>
						</div>
					</div>

					<div class="row" v-if="flagSimples || flagCompleto">
						<!-- ALTURA CARGA -->
						<div class="col-xs-12 col-md-6 form-group">
							<label> Altura (m):</label>
							<input
								type="number"
								step="0.1"
								placeholder="0,0"
								v-model="item.altura"
								class="form-control input-sm"
								:disabled="solicitacao_aprovada"
							></input>
						</div>

						<!-- COMPRIMENTO CARGA -->
						<div class="col-xs-12 col-md-6 form-group">
							<label> Comprimento (m):</label>
							<input
								type="number"
								step="0.1"
								placeholder="0,0"
								v-model="item.comprimento"
								class="form-control input-sm"
								:disabled="solicitacao_aprovada"
							></input>
						</div>

						<!-- LARGURA CARGA -->
						<div class="col-xs-12 col-md-6 form-group">
							<label> Largura (m):</label>
							<input
								type="number"
								step="0.1"
								placeholder="0,0"
								v-model="item.largura"
								class="form-control input-sm"
								:disabled="solicitacao_aprovada"
							></input>
						</div>

						<!-- LARGURA VOLUME -->
						<div class="col-xs-12 col-md-6 form-group">
							<label> Volume (m³):</label>
							<input
								type="number"
								step="0.1"
								placeholder="0,0"
								v-model="item.volume"
								class="form-control input-sm"
								:disabled="solicitacao_aprovada"
							></input>
						</div>
					</div>

					<div class="row" v-if="flagCompleto">
						<!-- TIPO EMBALAGEM -->
						<div class="col-xs-12 col-md-8 form-group"
						:class="{'has-error': item.erroEmbalagem != ''}">
							<label>* Tipo Embalagem:</label>
							<select
								class="form-control input-sm"
								v-model="item.tipo_embalagem"
								:disabled="solicitacao_aprovada"
							>
								<option value="">
									{{ _traducao('global', 'escolha').toUpperCase() }}
								</option>
								<option
									v-for="tipo in tipoEmbalagem"
									:key="tipo.id + 'tipoEmbalagem'"
									:value="tipo.id"
								>
									{{ tipo.descricao }}
								</option>
							</select>
							<p class="help-block" v-show="item.erroEmbalagem != ''">
								{{ item.erroEmbalagem }}
							</p>
						</div>

						<div class="col-xs-12 col-md-4 form-group">
							<label>{{ _traducao('global', 'fragil') }}</label> <br />
							<div class="btn-group print-button-group" role="group">
								<flSimNao
									:disabled="solicitacao_aprovada"
									v-model="item.carga_fragil"
								/>
							</div>
						</div>
					</div>

					<div class="row" v-if="flagCompleto">
						<!-- TIPO EMBALAGEM -->
						<div class="col-xs-12 form-group"
							:class="{'has-error': item.id_pass_erro != ''}">
							<label>* Passageiro:</label>
							<select
								class="form-control input-sm"
								v-model="item.id_passageiro"
								:disabled="solicitacao_aprovada"
							>
								<option value="">
									{{ _traducao('global', 'escolha').toUpperCase() }}
								</option>
								<option
									v-for="passageiro in passageiros"
									:key="passageiro.cpf + 'passageiro'"
									:value="passageiro.id_passageiro"
								>
									{{ passageiro.nome }}
								</option>
							</select>
							<p class="help-block" v-show="item.id_pass_erro != ''">
								{{ item.id_pass_erro }}
							</p>
						</div>

						<div class="col-xs-12" v-if="possuiTrechos">
							<!-- traduzir este label e o original -->
							<label>{{ _traducao('global', 'desmarqueTrechosCarg') }}:</label>
							<table class="table table-condensed" style="margin-bottom: 0px">
								<tbody>
									<tr
										style="vertical-align: middle; cursor: pointer"
										v-for="(trx, idx) in item.trecho"
										@click="!disabled ? atualizarTrecho(trx) : ''"
										:style="{
											'background-color': trx.esta
												? '#a9d796'
												: item.trechoErro
												? '#C9302C'
												: '',
											'color': trx.esta
												? 'black'
												: item.trechoErro
												? 'white'
												: 'black'
										}"
										:key="trx.id + 'trechoCarga'"
									>
										<td class="text-left" style="width: 100%">
											<small style="font-size: 10px; font-weight: 700">
												{{
													trx.pais_partida ? trx.pais_partida.descricao : ''
												}} </small
											><br />
											<small style="font-size: 10px; font-weight: 700">
												{{
													trx.designativo_partida
														? trx.designativo_partida.cidade
														: ''
												}}
												-
												{{
													trx.estado_partida ? trx.estado_partida.nome : ''
												}} </small
											><br />
											<small style="font-size: 10px; font-weight: 700">
												({{
													trx.designativo_partida
														? trx.designativo_partida.sigla
														: ''
												}})
												{{
													trx.designativo_partida
														? trx.designativo_partida.local
														: ''
												}}
												<br />
												{{ trx.descricao_partida }}
											</small>
										</td>

										<td class="text-center" style="vertical-align: middle">
											<i
												class="fa fa-arrow-right"
												style="font-size: 12px"
												aria-hidden="true"
											></i>
											<i
												class="fa fa-chevron-down"
												style="font-size: 10px"
												aria-hidden="true"
												v-if="idx < item.trecho.length - 1"
											></i>
										</td>

										<td
											class="text-right"
											style="width: 50%; vertical-align: middle"
										>
											<small style="font-size: 10px; font-weight: 700">
												{{
													trx.pais_destino ? trx.pais_destino.descricao : ''
												}} </small
											><br />
											<small style="font-size: 10px; font-weight: 700">
												{{ trx.estado_destino.nome }}
												-
												{{ trx.designativo_destino.cidade }} </small
											><br />
											<small
												style="font-size: 10px; font-weight: 700"
												v-if="!trx.nao_tem_aerodromo"
											>
												({{ trx.designativo_destino.sigla }})
												{{ trx.designativo_destino.local }}

												{{ trx.descricao_destino }}
											</small>
											<small
												style="font-size: 10px; font-weight: 700"
												v-if="!trx.nao_tem_aerodromo"
											>
												<br />
											</small>
										</td>
									</tr>
								</tbody>
								<p
									class="help-block"
									style="color: #c9302c"
									v-show="item.trechoErro"
								>
									{{ item.trechoErro }}
								</p>
							</table>
						</div>
					</div>
				</div>
			</div>
		</div>
		<modal ref="formCadastroTipoCarga">
			<div class="row">
				<div class="col-xs-12">
					<h4>
						{{ _traducao('global', 'cadastroTipoCarga').toUpperCase() }}
						<button
							type="button"
							class="close"
							@click="$refs.formCadastroTipoCarga.modalHide()"
						>
							<span aria-hidden="true">&times;</span>
						</button>
					</h4>
					<hr />
				</div>
				<div class="container-fluid conteudo">
					<flFormCadastroTipoCarga
						ref="cadTipoCarga"
						@tipo-carga-salvo="carregarTipoCargaRecemSalvo"
					/>
				</div>
			</div>
		</modal>
	</div>
</template>

<script>
import flFormCadastroTipoCarga from '@/modules/layout/admin-geral/tipo-carga/form/main.vue'

export default {
	components: {
		flFormCadastroTipoCarga
	},
	props: {
		form: {
			type: Object,
			required: true
		},
		solicitacao_aprovada: {
			type: Boolean,
			default: false
		},
		cargaArray: {
			type: Array,
			require: true
		},
		passageiros: {
			type: Array
		},
		disabled: {
			type: Boolean,
			default: false
		},
		possuiTrechos: {
			type: Boolean,
			default: true
		}
	},
	data() {
		return {
			tipoCarga: [],
			indexCadastro: null,
			flagComponente: $cliente.get('componente_carga_solicitacao'),
			tipoEmbalagem: [],
			cargaBagagem: 'carga/bagagem',
		}
	},
	computed: {
		flagSimples() {
			return this.flagComponente === 'basico' || 'simples'
		},
		flagCompleto() {
			return this.flagComponente === 'completo'
		},
		flagPeso(){
			return this.flagComponente === 'peso'
		}
	},
	watch: {
		'form.carga': function (val, oldVal) {
			if (val) {
				if (this.form.id == 0) {
					this.addCarga('+')
				}else if(this.form.id != 0 && !oldVal){
					this.addCarga('+')
				}
			} else {
				this.form.cargaArray = []
			}
		}
	},
	mounted() {
		this.parametros()
		this.carregaTipoCarga()
		this.carregaEmbalagemCarga()
	},
	methods: {
		procurarTipoCarga({tipo_carga}) {
			return this.tipoCarga.find(({id}) => id == tipo_carga)
		},
		alterarTipoCarga(index) {
			const classificacao = this.form.cargaArray[index].tipo_carga
				? this.procurarTipoCarga(this.form.cargaArray[index]).classificacao
				: ''
			switch (classificacao) {
				case 'LIQUIDA':
					this.form.cargaArray[index].carga_liquida = true
					this.form.cargaArray[index].carga_perigosa = false
					break
				case 'PERIGOSA':
					this.form.cargaArray[index].carga_liquida = false
					this.form.cargaArray[index].carga_perigosa = true
					break
				default:
					this.form.cargaArray[index].carga_liquida = false
					this.form.cargaArray[index].carga_perigosa = false
			}
		},

		abrirCadastroTipoCarga(index) {
			this.$refs.formCadastroTipoCarga.modalShow(80)
			this.$refs.cadTipoCarga.limparDados()
			this.indexCadastro = index
		},

		carregarTipoCargaRecemSalvo(tipoCarga) {
			tipoCarga.trecho = []

			if (this.possuiTrechos) {
				this.form.trecho.forEach((trecho) => {
					tipoCarga.trecho.push({...trecho, esta: true})
				})
			}

			this.$refs.formCadastroTipoCarga.modalHide()
			this.tipoCarga.push({...tipoCarga, tipo_carga: tipoCarga.id})
			this.form.cargaArray[this.indexCadastro].tipo_carga = tipoCarga.id
			this.alterarTipoCarga(this.indexCadastro)
		},

		atualizarTrecho(trecho) {
			trecho.esta = !trecho.esta
			this.$forceUpdate()
		},

		editar(item) {
			return item.itens_carga.map((o) => {
				return {
					id: o.id,
					id_solicitacao: o.id_solicitacao,
					tipo_carga: '',
					id_passageiro: '',
					descricao: o.descricao,
					carga_liquida: o.carga_liquida == '1',
					carga_perigosa: o.carga_perigosa == '1',
					peso: this.parseFloat(o.peso, 2),
					altura: this.parseFloat(o.altura, 2),
					comprimento: this.parseFloat(o.comprimento, 2),
					largura: this.parseFloat(o.largura, 2),
					volume: this.parseFloat(o.volume, 2),
					tipo_embalagem: o.tipo_embalagem == '0' ? '' : o.tipo_embalagem,
					descricaoErro: '',
					pesoErro: '',
					erro_tipo_carga: ''
				}
			})
		},

		toNumberCasa(val, casas) {
			return Number(Number(val).toFixed(casas))
		},

		addCarga(sinal) {
			if (sinal == '+') {
				let data = {
					id: 0,
					descricao: '',
					descricaoErro: '',
					carga: '',
					cargaErro: '',
					carga_perigosa: false,
					erroEmbalagem: '',
					id_pass_erro: '',
					peso: '',
					pesoErro: '',
					volume: '',
					largura: '',
					altura: '',
					comprimento: '',
					tipo_embalagem: '',
					tipo_carga: '',
					id_passageiro: '',
					carga_liquida: false,
					carga_fragil: false,
					erro_tipo_carga: '',
					trecho: []
				}

				if (this.possuiTrechos) {
					for (var i in this.form.trecho) {
						data.trecho.push({...this.form.trecho[i], esta: true})
					}
				}

				this.form.cargaArray.push(data)
			}

			if (sinal == '-') {
				this.form.cargaArray.splice(this.form.cargaArray.length - 1, 1)
			}

			// this.cargaArray.push(data)
		},

		validaForm(form = false, cargaArray = false) {
			if (!form) {
				form = this.form
			}
			if (!cargaArray) {
				cargaArray = this.cargaArray
			}

			let passou = true
			let obg = this._traducao('global', 'campoObrigatorio')
			if (form.carga) {
				for (let i in cargaArray) {
					if (cargaArray[i].descricao.trim() == '') {
						cargaArray[i].descricaoErro = obg
						passou = false
					} else {
						cargaArray[i].descricaoErro = ''
					}
					if (cargaArray[i].peso == 0) {
						cargaArray[i].pesoErro = obg
						passou = false
					} else {
						cargaArray[i].pesoErro = ''
					}
					if (cargaArray[i].tipo_carga == '' && this.flagCompleto) {
						cargaArray[i].erro_tipo_carga = obg
						passou = false
					} else {
						cargaArray[i].descricao_tipo_carga = this.procurarTipoCarga(
							cargaArray[i]
						).descricao
						cargaArray[i].erro_tipo_carga = ''
					}
					if (cargaArray[i].tipo_embalagem && this.flagCompleto) {
						cargaArray[i].descricao_tipo_embalagem = this.tipoEmbalagem.find(
							({id}) => id == cargaArray[i].tipo_embalagem
						)?.descricao
					}
					let estaEmTrecho = cargaArray[i].trecho.findIndex(
						(trecho) => trecho.esta == true
					)
					if (estaEmTrecho == -1 && this.flagCompleto) {
						cargaArray[i].trechoErro = obg
						passou = false
						bus.$emit('exibir-notificacao', {
							type: 'danger',
							text: this._traducao('global', 'escolhaPeloMenosUmTrechoCarga')
						})
						return
					} else {
						cargaArray[i].trechoErro = ''
					}
				}
			}

			if (passou) {
				this.$emit('carga-transportada', {cargaArray: cargaArray})
			}

			return passou
		},
		carregaTipoCarga() {
			this._httpGet('Tipo_carga/lista', (response) => {
				this.tipoCarga = response.lista
			})
		},
		carregaEmbalagemCarga() {
			this._httpGet('Tipo_embalagem_carga/lista', (response) => {
				this.tipoEmbalagem = response.lista
			})
		},

		parametros(){
			this._getParametro(119).then(
				(valor) => (this.cargaBagagem = valor)
			)
		}
	}
}
</script>